import { getAuth } from 'firebase/auth';
import { VMAuthStorage } from './vmAuthStorage';

export const extractSuffixFromField = (sk, prefix) => {
  //console.log("extracting uuid from sk: " + sk + " prefix: " + prefix);
  if (!sk) return '';
  return sk.replace(`${prefix}#`, '');
};

export const extractTopicIdFromGSI1SK = (gsi1sk) => {
  if (!gsi1sk) return '';
  const parts = gsi1sk.split('#');
  return parts.length >= 2 ? parts[1] : '';
};

export const extractDateFromGSI1SK = (gsi1sk) => {
  if (!gsi1sk) return 'No date';
  // Input format: "TOPIC#uuid#timestamp"
  try {
    // Extract timestamp from TOPIC#uuid#timestamp format
    const parts = gsi1sk.split('#');
    const timestamp = parts[parts.length - 1]; // Get the last part

    const date = new Date(timestamp);
    if (isNaN(date.getTime())) {
      return 'Invalid date format';
    }
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Error formatting date';
  }
};

export async function sendRequest(url, jsonData) {
  const token = VMAuthStorage.getAuthToken();
  const systemUserId = VMAuthStorage.getSystemUserId();

  if (!token) {
    throw new Error('No authentication token found');
  }

  const headers = {
    'Content-Type': 'application/json;charset=UTF-8',
    'Authorization': `Bearer ${token}`
  };

  // Add userId to the request data automatically
  const requestData = {
    ...jsonData,
    userId: systemUserId,
    headers: headers
  };
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(requestData)
  });

  if (!response.ok) {
    if (response.status === 401) {
      // Handle unauthorized access - could redirect to login or clear token
      VMAuthStorage.clearAllAuthData();
      throw new Error('Authentication expired');
    }
    throw new Error(`Request failed with status: ${response.status}`);
  }

  return await response.json();
}
